import { render, staticRenderFns } from "./WebcamStreamFaceDetectorLiveness.vue?vue&type=template&id=053d0f3c&scoped=true"
import script from "./WebcamStreamFaceDetectorLiveness.vue?vue&type=script&lang=js"
export * from "./WebcamStreamFaceDetectorLiveness.vue?vue&type=script&lang=js"
import style0 from "./WebcamStreamFaceDetectorLiveness.vue?vue&type=style&index=0&id=053d0f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d0f3c",
  null
  
)

export default component.exports